import { useState } from 'react'

import { Modal, ModalContent } from '@/components/modal/Modal'
import { ModalFooterWithActions } from '@/components/modal/ModalFooterWithActions'

interface TransferOwnershipConfirmModalProps {
  memberName: string
  matterName: string
  onClose: () => void
  onConfirm: () => Promise<string | null>
}

export function TransferOwnershipConfirmModal({ memberName, matterName, onClose, onConfirm }: TransferOwnershipConfirmModalProps) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleConfirm = async () => {
    setError(null)
    setLoading(true)
    try {
      const transferError = await onConfirm()
      if (transferError) {
        setError(transferError)
        setLoading(false)
      } else {
        onClose()
      }
    } catch {
      setError('Could not transfer ownership. Try again.')
      setLoading(false)
    }
  }

  return (
    <Modal open onOpenChange={(nextOpen) => !nextOpen && !loading && onClose()}>
      <ModalContent
        width="sm"
        height="max-full"
        stacked
        preventDismiss={loading}
        className="max-w-[448px]"
        title="Transfer ownership?"
        subtitle={`Make ${memberName} the owner of ${matterName}?`}
        subtitleClassName="break-words"
        footer={
          <ModalFooterWithActions
            inlineMessage={error ? { variant: 'error', children: error } : undefined}
            secondaryAction={{ label: 'Cancel', onClick: onClose, disabled: loading }}
            primaryAction={{ label: 'Transfer ownership', onClick: handleConfirm, loading }}
          />
        }
      >
        <p className="font-sans text-base font-normal leading-6 tracking-[-0.32px] text-brand-neutral-950">
          You will stay on this matter as a Contributor. Only the new owner will be able to remove members and edit medical chronologies, timelines, and medical
          bills.
        </p>
      </ModalContent>
    </Modal>
  )
}
